import { AfterViewInit, Component, ViewChild, ViewContainerRef} from '@angular/core';
import {  NJReadDocDefTemplateLookup, NJDocDefTemplate } from "../../DOData";
//import { DocDefPrimLibService } from '../../../doc-def-prim-lib.service';
//import { ICellEditorAngularComp } from 'ag-grid-angular/main';

@Component({
    selector: 'dropdown-renderer',
    templateUrl: './dropdown-cell-rending.component.html',
    styleUrls: ['./dropdown-cell-rending.component.css']
})
//export class DropdownRendererComponent implements ICellEditorAngularComp, AfterViewInit {
export class DropdownRendererComponent {
    private lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup> = new Array<NJReadDocDefTemplateLookup>();
    public selectedLookup: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup();
    private origHeight: number;
    public isDisabled: boolean = false;

    private params;
    private LookupId: number;
    private DropdownHeight :number;
    private template: NJDocDefTemplate;
    public dropdown: boolean = false;
    private action:string =""
    //@ViewChild('input', { read: ViewContainerRef }) public input;
    agInit(params): void {
        this.params = params;
        
        //this.LookupId = this.params.valueFormatter;
        this.LookupId = this.params.value;
        this.template = params.template;
        this.dropdown = params.dropdown;
        this.origHeight = params.node.rowHeight;
        this.DropdownHeight = params.DropdownHeight;
        this.lstDocDefTemplateLookup = this.params.lstDocDefTemplateLookup || null;
        if (this.LookupId > 0) {
            if (this.lstDocDefTemplateLookup) {
                for (var i = 0; i < this.lstDocDefTemplateLookup.length; i++) {
                    if (this.lstDocDefTemplateLookup[i].lookupId == this.LookupId && this.lstDocDefTemplateLookup[i].lookupTypeId == this.template.lookupTypeId) {
                        this.selectedLookup = DropdownRendererComponent.createCopy(this.lstDocDefTemplateLookup[i]);
                    }
                }
            }
        }
        else {
            this.selectedLookup.active = "N";
            this.selectedLookup.longDesc ="No Data";
        }
        this.selectedLookupDesc = this.selectedLookup.longDesc;
    }
    //getSelectedLookupDesc() {
    //        return this.selectedLookup.longDesc;
    //}
    //converted to property for binding purposes
    private _selectedLookupDesc: string;
    public get selectedLookupDesc() {
        return this._selectedLookupDesc;
    }

    public set selectedLookupDesc(theSelectedLookupDesc: string) {
        this._selectedLookupDesc = theSelectedLookupDesc;
    }

    onSelectItem(LookupId): void {
        this.LookupId = LookupId;
        this.onClick(+this.LookupId);
        this.selectedLookup = this.lstDocDefTemplateLookup.filter((template: NJReadDocDefTemplateLookup) => {
            return ( template.lookupId == LookupId)
        })[0];
        this.selectedLookupDesc = this.selectedLookup.longDesc;
    }
    getLookupDesc(lookup: NJReadDocDefTemplateLookup) {
        return lookup.longDesc;
    }
    getLstDocDefTemplateLookup(): Array<NJReadDocDefTemplateLookup> {
        let ret: Array<NJReadDocDefTemplateLookup> = this.lstDocDefTemplateLookup.filter((template: NJReadDocDefTemplateLookup) => {
            return ((template.active == 'Y' || template.active == 'D' || template.active == '1') && template.lookupTypeId == this.template.lookupTypeId)
        });
        return ret;
    }
    static createCopy(objectToCopy: NJReadDocDefTemplateLookup): NJReadDocDefTemplateLookup {
        if (objectToCopy)
            return (JSON.parse(JSON.stringify(objectToCopy)));
        else return undefined;
    }
    //inResetRowHeights: boolean = false;
    onClick($event) {
        if (this.params.onClick instanceof Function) {
            // put anything into params u want pass into parents component
            //if ($event == 'resetRowHeights')
            //    this.inResetRowHeights = true;
            //if ($event == 'blur' && this.inResetRowHeights) {
            //    this.inResetRowHeights = false;
            //    console.log("ignor blur");
            //    return;
            //}
            
            const params = {
                event: $event,
                origHeight: this.origHeight,
                DropdownHeight: this.DropdownHeight,
                node: this.params.node,
                value: this.LookupId,
                template: this.template,
                action: this.action
            }
            this.params.onClick(params);
            console.log($event)
        }
    }
    //getValue(): any {
    //    return this.LookupId;
    //}
    //ngAfterViewInit() {
    //window.setTimeout(() => {
    //    this.input.element.nativeElement.focus();
    //})
    //}
}
